import { render, staticRenderFns } from "./GoodsPos.vue?vue&type=template&id=44ed0ca4&scoped=true"
import script from "./GoodsPos.vue?vue&type=script&lang=js"
export * from "./GoodsPos.vue?vue&type=script&lang=js"
import style0 from "./GoodsPos.vue?vue&type=style&index=0&id=44ed0ca4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44ed0ca4",
  null
  
)

export default component.exports